import { render } from "./OtHours.vue?vue&type=template&id=72a9260e&scoped=true"
import script from "./OtHours.vue?vue&type=script&lang=js"
export * from "./OtHours.vue?vue&type=script&lang=js"

import "./OtHours.vue?vue&type=style&index=0&id=72a9260e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a9260e"]])

export default __exports__